import getInstance from "app/config/api";

export default class Payment {
  static async fetchPaymentDischarge(params) {
    const instance = getInstance();
    const { data } = await instance.get("/payment/discharge", { params });
    return data;
  }
  static async fetchJobMateraSettlementHistory(params) {
    const instance = getInstance();
    const { data } = await instance.get("/payment/jobMateraSettlementControl", {
      params,
    });
    return data;
  }
}
